export default __webpack_public_path__ + "static/media/logo.ac600174.svg";